import { emptyAdminApi as api } from "../emptyAdminApi";
import type {
  KycActivationOptions,
  KycDetails,
  KycInventoryRow,
  KycResult,
  KycRow,
  KycSummary,
} from "../../../components/distributors/inventory/kyc";

type KycDetailsResponse = KycSummary &
  KycActivationOptions & {
    iccid: string;
    details: KycDetails;
  };

const path = "/portal/distributor-kyc";

export const distributorKycApi = api
  .enhanceEndpoints({ addTagTypes: ["DistributorInventory"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getDistributorKycInventory: build.query<
        { inventory: KycInventoryRow[] },
        string
      >({
        query: (distributorId) => ({
          url: path,
          params: { distributorId },
        }),
        providesTags: ["DistributorInventory"],
      }),
      getDistributorKycDetails: build.query<
        KycDetailsResponse,
        { distributorId: string; iccid: string }
      >({
        query: (params) => ({ url: path, params }),
      }),
      submitDistributorKyc: build.mutation<
        { rows: KycResult[] },
        { distributorId: string; rows: KycRow[] }
      >({
        query: (body) => ({
          url: path,
          method: "POST",
          body,
        }),
      }),
    }),
  });

export const {
  useGetDistributorKycInventoryQuery,
  useGetDistributorKycDetailsQuery,
  useSubmitDistributorKycMutation,
} = distributorKycApi;
